import React from 'react'

import { DeliveryReportHeader } from 'components/DeliveryReportHeader'

import type { ShipmentListItem, TabStatus } from '../type'
import { ShipmentItem } from './ShipmentItem'
import styles from './DeliveryListView.module.css'

type Props = {
  tenantName: string
  activeTab: TabStatus
  shipments: ShipmentListItem[]
  deliveryReportUid: string
  onTabChange: (tab: TabStatus) => void
  onShipmentClick: (shipmentUid: string) => void
  onNewDelivery: () => void
}

export const DeliveryListView: React.FC<Props> = ({
  tenantName,
  activeTab,
  shipments,
  deliveryReportUid,
  onTabChange,
  onShipmentClick,
  onNewDelivery,
}) => (
  <div className={styles.page}>
    <DeliveryReportHeader
      title="配送一覧"
      deliveryReportUid={deliveryReportUid}
      onNewDelivery={onNewDelivery}
    />

    <div className={styles.tenantLabelRow}>
      <p className={styles.tenantLabel}>出荷元テナント</p>
    </div>
    <div className={styles.tenantNameRow}>
      {activeTab === 'completed' ? (
        <button className={styles.tenantNameLink} onClick={onNewDelivery}>
          {tenantName}
        </button>
      ) : (
        <p className={styles.tenantName}>{tenantName}</p>
      )}
    </div>

    <div className={styles.tabs}>
      <button
        className={`${styles.tab} ${activeTab === 'active' ? styles.tabActive : ''}`}
        onClick={() => onTabChange('active')}
      >
        配送中
      </button>
      <button
        className={`${styles.tab} ${activeTab === 'completed' ? styles.tabActive : ''}`}
        onClick={() => onTabChange('completed')}
      >
        完了
      </button>
    </div>

    <div className={styles.list}>
      {shipments.length === 0 ? (
        <p className={styles.emptyText}>データがありません</p>
      ) : (
        shipments.map((shipment) => (
          <ShipmentItem
            key={shipment.uid}
            shipment={shipment}
            activeTab={activeTab}
            onClick={() => onShipmentClick(shipment.uid)}
          />
        ))
      )}
    </div>
  </div>
)
